module.exports = __webpack_public_path__ + "static/media/game_banner@768.90b19d4a.png";